import axios from 'axios';
import {API_ADMIN} from '@/utils/constants/Api';
import { AuditInstanceModel } from '@/audit/models/AuditInstanceModel';
import { AuditInstanceFlowModel } from '@/audit/models/AuditInstanceFlowModel';
import { IFilterList } from '@/utils/interfaces/FilterListInterface';
import { AuditMuvenApiModel } from '../models/AuditMuvenApiModel';

export default {
    getMuvenApiInfo(page:number, filterList:IFilterList):Promise<AuditMuvenApiModel[]> {
        return axios.get(`${API_ADMIN}audits/api?page=${page}${filterList.toPartialQueryString()}`)
            .then(({data}) => data.map((d:AuditMuvenApiModel) => new AuditMuvenApiModel(d)));
    },

    getMuvenApiInfoById(id: string):Promise<AuditMuvenApiModel> {
        return axios.get(`${API_ADMIN}audits/api/${id}`)
            .then(({data}) => new AuditMuvenApiModel(data));
    },

    getInstances(page:number, filterList:IFilterList):Promise<AuditInstanceModel[]> {
        return axios.get(`${API_ADMIN}audits/instances?page=${page}${filterList.toPartialQueryString()}`)
            .then(({data}) => data.map((a:AuditInstanceModel) => new AuditInstanceModel(a)));
    },

    getInstanceById(id:string):Promise<AuditInstanceModel> {
        return axios.get(`${API_ADMIN}audits/instances/${id}`)
            .then(({data}) => new AuditInstanceModel(data));
    },

    getInstanceFlowById(id:string):Promise<AuditInstanceFlowModel> {
        return axios.get(`${API_ADMIN}audits/instances/flow/${id}`)
            .then(({data}) => new AuditInstanceFlowModel(data));
    },
}
